import { Textarea } from '@/components/ui/textarea';
import { Lightbulb } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

interface CreativeContextInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  showSuggestions?: boolean;
}

const examplePrompts = [
  'Make the person look 10 years older',
  'Change the background to a beach sunset',
  'Add dramatic lighting and shadows',
  'Keep the logo centered when extending',
];

export function CreativeContextInput({ value, onChange, disabled, showSuggestions = true }: CreativeContextInputProps) {
  const isMobile = useIsMobile();
  
  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-foreground flex items-center gap-2">
        <Lightbulb className="h-4 w-4 text-primary" />
        Creative Context <span className="text-muted-foreground">(optional)</span>
      </label>
      <Textarea
        placeholder="Describe any specific changes you'd like... (e.g., change background, modify lighting, age transformation)"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className={`bg-secondary/30 border-border focus:border-primary resize-none ${isMobile ? 'min-h-[78px]' : 'min-h-[60px]'}`}
      />
      {showSuggestions && (
        <div className="flex flex-wrap gap-1.5">
          {examplePrompts.map((prompt) => (
            <button
              key={prompt}
              onClick={() => onChange(prompt)}
              disabled={disabled}
              className="text-xs px-2 py-1 bg-secondary rounded-full text-muted-foreground hover:text-foreground hover:bg-secondary/80 transition-colors disabled:opacity-50"
            >
              {prompt}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
